import { UpdateBenefitActivationDTO } from 'probonio-shared-ui/api';
import { useCallback } from 'react';
import { DialogState } from '../../../component/dialog';
import { RowSelectionState } from '../../../component/table/useManualRowSelection';
import { useBenefitContext } from '../BenefitContext';
import { EmployeeFilter } from '../employeeStatusList/employeeFilterState';
import { ActivationActionsDialog } from './ActivationActionsDialog';
import { PauseMutationDTO, useBulkPauseActivationsMutation } from './useBulkPauseActivationsMutation';
import { useBulkUpdateActivationsMutation } from './useBulkUpdateActivationsMutation';

interface Props {
  dialogState: DialogState;
  employeeFilter: EmployeeFilter;
  rowSelectionState: RowSelectionState;
}

export const BulkEditActivationsDialog: React.FC<Props> = ({ dialogState, employeeFilter, rowSelectionState }) => {
  const { benefit, customBenefit } = useBenefitContext();

  const bulkUpdateMutation = useBulkUpdateActivationsMutation(employeeFilter, rowSelectionState, benefit, customBenefit?.id);
  const bulkPauseMutation = useBulkPauseActivationsMutation(employeeFilter, rowSelectionState, benefit, customBenefit?.id);

  const handleDeactivate = useCallback((dto: UpdateBenefitActivationDTO) => bulkUpdateMutation.mutateAsync(dto), [bulkUpdateMutation]);

  const handlePause = useCallback((dto: PauseMutationDTO) => bulkPauseMutation.mutateAsync(dto), [bulkPauseMutation]);

  const handleUpdate = useCallback((dto: UpdateBenefitActivationDTO) => bulkUpdateMutation.mutateAsync(dto), [bulkUpdateMutation]);

  return (
    <ActivationActionsDialog
      dialogState={dialogState}
      translationPrefix="bulkEditDialog"
      isBulkMode
      onDeactivate={handleDeactivate}
      onPause={handlePause}
      onUpdate={handleUpdate}
      onSuccessReset={rowSelectionState.handleReset}
    />
  );
};
